import { useQuery } from '@tanstack/react-query';

import { fetchListFiveApi } from '../api';

export default function useListFiveQuery(params: any, options?: any) {
  return useQuery(
    ['list', 'five', params],
    () => fetchListFiveApi(params),
    options
  );
}
